// -----------------------------------------------------------------------------
// ConfirmationActionModal.jsx – styled comme AddAppelOffreForm
// -----------------------------------------------------------------------------
import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
  styled,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

/* ────────────────────────────────────────────────────────────────────────── */
/*  🎨   DESIGN TOKENS – identiques à AddAppelOffreForm                      */
/* ────────────────────────────────────────────────────────────────────────── */
const NAVY       = "#2F4E8B";
const NAVY_LIGHT = "#4a6bad";
const LABEL_GREY = "#4F5565";
const OUTLINE    = "#D4D9E0";

/* ───  Paper dégradé identique aux captures                                   */
const GradientPaper = styled(Paper)(({ theme }) => ({
  position: "relative",
  borderRadius: 3,
  padding: theme.spacing(4),
  width: "100%",
  maxWidth: 400,
  margin: "0 auto",
  background: "linear-gradient(135deg, #FFFFFF 0%, #F6F9FC 60%, #E9F0F9 100%)",
  boxShadow: theme.shadows[8],
  outline: "none",
}));

export default function ConfirmationActionModal({
  open,
  onClose,
  onConfirm,
  message,
}) {
  return (
    <Modal
      open={open}
      onClose={null} // Disable closing on backdrop click
      BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.3)" } }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
        }}
      >
        <GradientPaper>
          {/* Close Icon */}
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              color: LABEL_GREY,
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Message */}
          <Typography
            variant="h6"
            align="center"
            sx={{
              fontWeight: 700,
              color: NAVY,
              mb: 3,
            }}
          >
            {message}
          </Typography>

          {/* Actions */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mt: 1,
            }}
          >
            <Button
              variant="contained"
              onClick={onConfirm}
              sx={{
                backgroundColor: NAVY,
                color: "#FFF",
                textTransform: "none",
                fontWeight: "bold",
                borderRadius: 1,
                px: 3,
                "&:hover": { backgroundColor: NAVY_LIGHT },
                minWidth: 100,
              }}
            >
              Confirmer
            </Button>

          </Box>
        </GradientPaper>
      </Box>
    </Modal>
  );
}
